import React from 'react';
import { SectionWrapper } from './ui/SectionWrapper';
import { TestimonialCard } from './ui/TestimonialCard';
export function Testimonials() {
  const testimonials = [{
    name: 'Carlos M.',
    country: 'México',
    quote: 'Por fin una guía en español que no promete hacerte millonario. Me ayudó a entender los costos reales y elegir arbitraje como primer modelo. Muy claro y práctico.'
  }, {
    name: 'Laura P.',
    country: 'Colombia',
    quote: 'Vivo fuera de USA y pensaba que era imposible vender en Amazon.com. El módulo de vender desde otros países me abrió los ojos. Ya tengo mi cuenta lista.'
  }, {
    name: 'Andrés R.',
    country: 'España',
    quote: 'El plan de 30 días es oro. En vez de perderme en YouTube, seguí los pasos del ebook y en 3 semanas ya tenía mi primer envío a FBA.'
  }];
  return <SectionWrapper data-id="element-259">
      <div className="text-center mb-12" data-id="element-260">
        <h2 className="text-3xl font-bold text-slate-900 mb-2" data-id="element-261">
          Lo que dicen quienes ya lo leyeron
        </h2>
        <p className="text-sm text-slate-400" data-id="element-262">
          (Testimonios de ejemplo — se actualizarán con reseñas reales)
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-263">
        {testimonials.map((t, i) => <TestimonialCard key={i} name={t.name} country={t.country} quote={t.quote} delay={i * 0.1} data-id="element-264" />)}
      </div>
    </SectionWrapper>;
}